import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({providedIn: 'root'})
export class NavigationService
{
    private readonly _httpClient = inject(HttpClient);
    private readonly _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);


    /**
     * Constructor
     */
    constructor(
        private readonly _translocoService: TranslocoService
    )
    {
    }    
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    get(): Observable<Navigation> {
        return this._httpClient.get<Navigation>('api/common/navigation').pipe(
            tap((navigation) => {
                
                const translatedNavigation = this.translateNavigation(navigation);
                this._navigation.next(translatedNavigation);
            })
        );
    }

    /**
     * Función recursiva para traducir la navegación y los subelementos
     */
    private translateNavigation(navigation: Navigation): Navigation {
        // Traducir los items principales
        navigation.default = navigation.default.map((item) => this.translateMenuItem(item));
        return navigation;
    }

    /**
     * Función para traducir cada item del menú
     */
    private translateMenuItem(item: any): any {
        
        const translatedItem = {
            ...item,
            title: this._translocoService.translate(item.title),
            subtitle: this._translocoService.translate(item.subtitle),
        };

        // Si el item tiene hijos, traducirlos también
        if (item.children) {
            translatedItem.children = item.children.map((child: any) =>
                this.translateMenuItem(child)
            );
        }

        return translatedItem;
    }    
}
